<template>
    <div ref="customServiceBox" class="customService">
      <p class="loading">正在连接客服...</p>
      <iframe :src="customServiceURL" frameborder="0"></iframe>
      <div @click="closeCustomService" class="close">
        <i style="display: none" class="iconfont icon-cha"></i>
      </div>
    </div>
</template>

<script>
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  import Bus from 'common/js/bus.js';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  export default {
    name: "customService",
    data() {
      return {

      }
    },
    computed: {
      customServiceURL(){
        return apiConfig.REQUEST_URL+'/shall/plus/kf/index.html'
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      closeCustomService(){
        this.$emit('closeCustomService',{})
      },
    },
    mounted() {
      this.updateModalZIndex(this.$el)
      Bus.$on('setCustomServiceZIndexTop',(ev)=>{
        this.updateModalZIndex(this.$el)
      })
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../common/stylus/config.styl"
  .customService
    width 915px
    height 735px
    box-shadow 1px 1px 3px #666
    border-radius 10px
    overflow hidden
    margin auto
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    z-index 999
    background-color #f1f1f1
    @media screen and (max-width: smallScreenWidth)
      width 650px
      height 500px
    &>iframe
      width 100%
      height 100%
    .loading
      font-size 14px
      position absolute
      z-index -1
      text-align center
      width 100%
      color #666666
      line-height 735px

    .close
      position absolute
      width 45px
      height 40px
      right 0
      top 0
      background-color transparent
</style>



// WEBPACK FOOTER //
// src/components/globalComp/customService.vue